import { ErrorStateScheduleEnum } from '../error-state-schedule.enum';

export enum PanelOrdersEditResolverErrorStatesEnum {
    GetOrderFailed = ErrorStateScheduleEnum.FundOrdersEditReportResolverStatesStartIndex,
    OrderNotFound,
    GetOrderStatusTriggersFailed,
    GetClientFailed
}
